import React from "react";
import { t } from "../../i18n";
import { FileList } from "./PdfDropzone";
import { Section } from "./parts";
import { EmailComposerState } from "./useEmailComposer";

const Chips: React.FC<{ title: string; names: string[] }> = ({ title, names }) =>
  names.length === 0 ? null : (
    <Section title={t("sharing.email.group", { title, count: names.length })}>
      <div className="flex flex-wrap gap-1.5">
        {names.map((name) => (
          <span key={name} className="max-w-full break-words rounded-full bg-primary-soft px-2.5 py-1 text-caption font-semibold text-primary">
            {name}
          </span>
        ))}
      </div>
    </Section>
  );

/** Passo 2 do e-mail: confere destinatários, anexos e mensagem antes de enviar. */
export const EmailReviewStep: React.FC<{ s: EmailComposerState }> = ({ s }) => (
  <div className="flex flex-col gap-5">
    <p className="text-caption text-fg-muted">{t("sharing.email.reviewIntro")}</p>
    <Chips title={t("sharing.email.hospitals")} names={s.selectedHospitals.map((h) => h.name)} />
    <Chips title={t("sharing.email.companies")} names={s.selectedCompanies.map((c) => c.name)} />
    <Chips title={t("sharing.email.reservas")} names={s.selectedReservas.map((r) => r.name)} />
    <Section title={t("sharing.email.attachments", { count: s.files.length })}>
      <FileList files={s.files} />
    </Section>
    <Section title={t("sharing.messagePreview")}>
      <div className="whitespace-pre-line break-words rounded-control border border-line bg-surface-muted p-3.5 text-caption text-fg-secondary">
        <strong className="mb-1.5 block text-label text-fg">{s.subject}</strong>
        {s.body}
      </div>
    </Section>
  </div>
);
